// apps/web/src/hooks/useAnalyticsDecideTopVictimCountries.ts
//
// P8a Decide tab — top-N victim countries last 7 days, with sufficiency
// gate. When the geo signal fails sufficiency, the route now returns
// fallbackSectors + geoReasonCode directly, so this hook is a single
// request with no second call needed.

import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export interface DecideGeoBucket {
  countryIso2: string
  count: number
}

export interface DecideSectorBucket {
  sectorSlug: string
  count: number
}

export interface DecideTopVictimCountriesResponse {
  sufficient: boolean
  geoReasonCode?: 'insufficient_geo'
  buckets: DecideGeoBucket[]
  fallbackSectors?: DecideSectorBucket[]
}

export function useAnalyticsDecideTopVictimCountries() {
  return useQuery<DecideTopVictimCountriesResponse>({
    queryKey: ['analytics', 'decide', 'top-victim-countries'],
    queryFn: () =>
      api.get<DecideTopVictimCountriesResponse>(
        '/stories/analytics/decide/top-victim-countries',
      ),
    staleTime: 5 * 60 * 1000,
  })
}
